import * as React from "react";
import * as TabsPrimitive from "@radix-ui/react-tabs";
import { cn } from "../util";

export const Tabs = TabsPrimitive.Root;

export const TabsLista = React.forwardRef<
  React.ElementRef<typeof TabsPrimitive.List>,
  React.ComponentPropsWithoutRef<typeof TabsPrimitive.List>
>(({ className, ...props }, ref) => (
  <TabsPrimitive.List
    ref={ref}
    className={cn("inline-flex h-10 items-end gap-6 border-b border-linea", className)}
    {...props}
  />
));
TabsLista.displayName = "TabsLista";

/* Pestaña editorial: sin caja, subrayado de 2px en tinta cuando está activa. */
export const TabsDisparador = React.forwardRef<
  React.ElementRef<typeof TabsPrimitive.Trigger>,
  React.ComponentPropsWithoutRef<typeof TabsPrimitive.Trigger>
>(({ className, ...props }, ref) => (
  <TabsPrimitive.Trigger
    ref={ref}
    className={cn(
      "-mb-px border-b-2 border-transparent pb-2 font-ui text-sm font-semibold text-tinta-tenue transition-colors hover:text-tinta data-[state=active]:border-tinta data-[state=active]:text-tinta focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring",
      className,
    )}
    {...props}
  />
));
TabsDisparador.displayName = "TabsDisparador";

export const TabsContenido = React.forwardRef<
  React.ElementRef<typeof TabsPrimitive.Content>,
  React.ComponentPropsWithoutRef<typeof TabsPrimitive.Content>
>(({ className, ...props }, ref) => (
  <TabsPrimitive.Content
    ref={ref}
    className={cn("mt-4 focus-visible:outline-none", className)}
    {...props}
  />
));
TabsContenido.displayName = "TabsContenido";
